import { useMemo } from "react";
import { getSignedUrl } from "../services/images.service";
import { useQuery } from "@tanstack/react-query";
import { Image } from "../types/images";
import { QueryKeys } from "./queryKeys";

export const useImagesBySignedUrl = (
  images: Image[],
  size: "small" | "large"
) => {
  const { data: signedUrlResponse } = useQuery({
    queryKey: [
      QueryKeys.SignedUrl,
      images?.map((image) => image.id).join(","),
      size,
    ],
    queryFn: () =>
      getSignedUrl(
        (images || []).map((image) => image.fileName),
        size
      ),
    gcTime: 1000 * 60 * 15, // 15 minutes, doesn't reload images on every render
    staleTime: 1000 * 60 * 15, // 15 minutes, doesn't refetch images on every render (no new network request)
    enabled: !!images,
  });

  const signedImageUrls = useMemo(() => {
    let result: string[] = [];
    if (signedUrlResponse && Array.isArray(signedUrlResponse.urls)) {
      result = signedUrlResponse.urls;
    }
    return result;
  }, [signedUrlResponse]);

  return signedImageUrls
    .map((url) => {
      const matchingImage = images?.find((image) =>
        url.includes(image.fileName)
      );
      if (matchingImage) {
        matchingImage.url = url;
        return matchingImage;
      }
      return null;
    })
    .filter((image) => image !== null) as Image[];
};
